import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Table,
  Label,
  Input,
  Spinner
} from "reactstrap";
import { Modal, Button, Form } from "react-bootstrap";

import Papa from "papaparse";
import axios from "axios";
import { API_BASE_URL } from "config.js";
import Swal from "sweetalert2";

function ContactLists() {
  const [exportModal, setExportModal] = useState(false);
  const [selectedExportList, setSelectedExportList] = useState("all");
  const [exportFileType, setExportFileType] = useState("csv");
  const [isExporting, setIsExporting] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [step, setStep] = useState(1);

  const handleDropdownChange = (key, event) => {
    setFields((prevFields) => ({
      ...prevFields,
      [key]: { ...prevFields[key], type: event.target.value },
    }));
  };
  const [selectedField, setSelectedField] = useState("");

  const [contactField, setContactField] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [currentStep, setCurrentStep] = useState(1);
  const [file, setFile] = useState(null);
  const [singleSelect, setSingleSelect] = useState("");
  const [val, setVal] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editData, setEditData] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [customFields, setCustomFields] = useState([]);
  const [contactList, setContactList] = useState([]);
  const [newListModal, setNewListModal] = useState(false);
  const [newListInput, setNewListInput] = useState("");
  const [isSavingList, setIsSavingList] = useState(false);
  const [newListStatus, setNewListStatus] = useState("active"); // default dropdown
  const [editListId, setEditListId] = useState(null);

  const [addSingleContactModal, setAddSingleContactModal] = useState(false);
  const [singleContactForm, setSingleContactForm] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    contactListId: ""
  });
  const [isSavingSingleContact, setIsSavingSingleContact] = useState(false);

  const [viewContactsModal, setViewContactsModal] = useState(false);
  const [viewingList, setViewingList] = useState(null);
  const [listContacts, setListContacts] = useState([]);
  const [isLoadingContacts, setIsLoadingContacts] = useState(false);

  const handleViewList = async (list) => {
    setViewingList(list);
    setViewContactsModal(true);
    setIsLoadingContacts(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/contacts/list/${list._id || list.id}`, {
        headers: getAuthHeaders()
      });
      if (response.data.success) {
        setListContacts(response.data.data);
      }
    } catch (err) {
      console.error("Error fetching contacts", err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Could not fetch contacts for this list."
      });
    } finally {
      setIsLoadingContacts(false);
    }
  };

  const handleDownloadExport = async (targetListId = null, targetListName = null) => {
    const listIdToExport = targetListId || selectedExportList || "all";
    let listNameForFile = targetListName;

    if (!listNameForFile) {
      if (listIdToExport === "all") {
        listNameForFile = "all_contacts";
      } else {
        const found = contactList.find(l => (l._id || l.id) === listIdToExport);
        listNameForFile = found ? found.listName : "contacts";
      }
    }

    try {
      setIsExporting(true);
      const response = await axios.get(`${API_BASE_URL}/contacts/export/${listIdToExport}`, {
        headers: getAuthHeaders(),
        responseType: "blob"
      });

      const safeName = listNameForFile.replace(/[^a-z0-9]/gi, "_").toLowerCase();
      const filename = listIdToExport === "all" ? `all_contacts_${Date.now()}.csv` : `contacts_${safeName}.csv`;

      const url = window.URL.createObjectURL(new Blob([response.data], { type: "text/csv" }));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      if (exportModal) {
        setExportModal(false);
      }

      Swal.fire({
        icon: "success",
        title: "Export Complete",
        text: `Contacts exported successfully as ${filename}.`,
        timer: 2500,
        showConfirmButton: false
      });
    } catch (err) {
      console.error("Error exporting contacts:", err);
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: "Could not export contacts. Please try again."
      });
    } finally {
      setIsExporting(false);
    }
  };

  const handleSingleContactChange = (e) => {
    const { name, value } = e.target;
    setSingleContactForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddSingleContact = async () => {
    try {
      if (!singleContactForm.phone && !singleContactForm.contactListId) {
        Swal.fire({
          icon: "warning",
          title: "Missing Fields",
          text: "Phone number and Contact List are required."
        });
        return;
      }
      if (!singleContactForm.phone) {
        Swal.fire({
          icon: "warning",
          title: "Missing Fields",
          text: "Phone number is required."
        });
        return;
      }
      if (!singleContactForm.contactListId) {
        Swal.fire({
          icon: "warning",
          title: "Missing Fields",
          text: "Contact List is required."
        });
        return;
      }
      setIsSavingSingleContact(true);
      
      const response = await axios.post(`${API_BASE_URL}/contacts/single`, singleContactForm, {
        headers: getAuthHeaders()
      });

      if (response.data.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Contact added successfully!"
        });
        setAddSingleContactModal(false);
        setSingleContactForm({ firstName: "", lastName: "", phone: "", contactListId: "" });
        fetchContactLists(); // Refresh lists to update the count
      }
    } catch (error) {
      console.error("Error adding contact", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to add contact. Please ensure phone is valid."
      });
    } finally {
      setIsSavingSingleContact(false);
    }
  };

  const confirmDelete = (id) => {
    setDeleteId(id);
    setDeleteModal(true);
  };
  const deleteConfirmed = () => {
    setPhoneNumbers((prev) => prev.filter((num) => num.id !== deleteId));
    setDeleteModal(false);
  };

  const [isCreatingNewList, setIsCreatingNewList] = useState(false);
  const [newListName, setNewListName] = useState("");
  const [newListNameError, setNewListNameError] = useState("");

  const [lists, setLists] = useState(["District 1 Contacts"]); // Initial lists

  const getAuthHeaders = () => {
    const token = localStorage.getItem("token");
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  const handleNewListClick = () => {
    setIsCreatingNewList(true);
  };

  // Update the new list name input
  const handleNewListChange = (event) => {
    setNewListName(event.target.value);
  };

  // Save the new list and update the dropdown
  const handleSaveNewList = () => {
    if (!newListName.trim()) return; // Prevent empty lists

    setLists([...lists, newListName]); // Add to dropdown
    setSelectedField(newListName); // Automatically select the new list
    setIsCreatingNewList(false);
    setNewListName(""); // Reset input
    setStep(4);
  };

  const [phoneNumbers, setPhoneNumbers] = useState([
    {
      id: 1,
      listName: "Main",
      countContact: "1200",
      isActive: true,
    },
    {
      id: 2,
      listName: "Supporter",
      countContact: "1300",
      isActive: false,
    },
    {
      id: 3,
      listName: "Donores",
      countContact: "1500",
      isActive: true,
    },
    {
      id: 4,
      listName: "Main Supporter",
      countContact: "1550",
      isActive: true,
    },
    {
      id: 5,
      listName: "Main Supporter",
      countContact: "1200",
      isActive: true,
    },
  ]);

  const handleSearchChange = (e) => {
    setVal(e.target.value);
  };

  const handleStatusChange = (e) => {
    setSingleSelect(e.target.value);
  };

  const toggleStatus = (id) => {
    setPhoneNumbers((prev) =>
      prev.map((num) =>
        num.id === id ? { ...num, isActive: !num.isActive } : num
      )
    );
  };

  const handleDrop = (event) => {
    event.preventDefault(); // Prevent default behavior (file open)

    const droppedFile = event.dataTransfer.files[0]; // Get the dropped file
    if (droppedFile) {
      setFile(droppedFile); // Set the selected file in the state
      parseCSVFile(droppedFile); // Process the file (if it's CSV)
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault(); // Prevent default behavior to allow the drop
  };

  const handleCreateNewList = async (name, status = "active") => {
    try {
      setIsSavingList(true);
      const payload = { listName: name, status };

      const response = await axios.post(
        `${API_BASE_URL}/contact-lists/add`,
        payload,
        {
          headers: getAuthHeaders(),
        }
      );

      if (response.data.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response.data.message,
        });
      }

      fetchContactLists(); // refresh
      setNewListModal(false);
      setNewListInput("");
      setNewListStatus("active");
    } catch (error) {
      console.error("Failed to create new list", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to create new contact list.",
      });
    } finally {
      setIsSavingList(false);
    }
  };


  const [csvData, setCsvData] = useState([]); // Store parsed CSV data
  const [csvHeaders, setCsvHeaders] = useState([]); // Store parsed CSV headers
  const [columnMappings, setColumnMappings] = useState({}); // Store mapped columns
  const [fields, setFields] = useState({
    name: "John",
    email: "Doe",
    phone: "+215482134",
  });

  const parseCSVFile = (file) => {
    const reader = new FileReader();
    reader.onload = () => {
      const fileContent = reader.result;
      Papa.parse(fileContent, {
        complete: (result) => {
          console.log(result.data); // Debug parsed data
          setCsvData(result.data); // Save the parsed data in your state
          if (result.meta && result.meta.fields) {
            setCsvHeaders(result.meta.fields);
            
            // Auto-detect mappings
            const initialMappings = {};
            result.meta.fields.forEach(hdr => {
              const lowerHdr = hdr.toLowerCase();
              if (lowerHdr.includes("phone") || lowerHdr.includes("mobile") || lowerHdr.includes("num")) {
                initialMappings[hdr] = "phone";
              } else if (lowerHdr.includes("first") || lowerHdr.includes("fname")) {
                initialMappings[hdr] = "firstName";
              } else if (lowerHdr.includes("last") || lowerHdr.includes("lname")) {
                initialMappings[hdr] = "lastName";
              } else if (lowerHdr.includes("loc") || lowerHdr.includes("district")) {
                initialMappings[hdr] = "location";
              } else {
                initialMappings[hdr] = "";
              }
            });
            setColumnMappings(initialMappings);
          }
        },
        header: true, // Assuming the first row contains headers
        skipEmptyLines: true,
      });
    };
    reader.readAsText(file);
  };

  // Step handling functions
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (
      selectedFile &&
      (selectedFile.type === "text/csv" ||
        selectedFile.name.endsWith(".xls") ||
        selectedFile.name.endsWith(".xlsx"))
    ) {
      setFile(selectedFile);
      parseCSVFile(selectedFile); // Parse file if it's of an acceptable type
    } else {
      alert("Please upload a valid CSV, XLS, or XLSX file");
    }
  };
  ///
  const handleMapping = (header, value) => {
    setFields((prevFields) => ({
      ...prevFields,
      [header]: value,
    }));
  };
  // Fetch custom fields from the server
  const fetchCustomFields = async () => {
    try {
      // setIsLoading(true);
      const response = await axios.get(`${API_BASE_URL}/custom-fields`, {
        headers: getAuthHeaders(),
      });
      console.log("response:", response);
      setCustomFields(response.data.data || []);

      // setIsLoading(false);
    } catch (error) {
      // setIsLoading(false);
      console.error("Error fetching custom fields:", error);
    }
  };

  // Example usage in your handleAddContactListfunction
  const handleAddContactList = async () => {
    try {
      if (!editData?.listName || !editData?.status) {
        setError("List Name and Status are required.");
        return;
      }

      const requestData = {
        listName: editData.listName,
        status: editData.status,
      };

      if (editMode) {
        await axios.put(
          `${API_BASE_URL}/contact-lists/update/${editData._id}`,
          requestData,
          { headers: getAuthHeaders() }
        );
      } else {
        await axios.post(`${API_BASE_URL}/contact-lists/add`, requestData, {
          headers: getAuthHeaders(),
        });
      }

      fetchContactLists();
      setShowModal(false);
      setEditMode(false);
      setEditData(null);
    } catch (error) {
      console.error("Error saving contact list:", error);
      setError("An error occurred.");
    }
  };

  // Fetch custom fields from the server
  const fetchContactLists = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${API_BASE_URL}/contact-lists`, {
        headers: getAuthHeaders(),
      });

      setContactList(response.data.data || []);
    } catch (error) {
      console.error("Error fetching contact lists:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchContactLists();
    fetchCustomFields();
  }, []);
  useEffect(() => {
    setFields({
      a: "John",
      b: "Doe",
      c: "786 123 1234",
      d: "District 1"
    });
  }, []);



  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const openRemoveModal = (id, listName) => {
    setRemoveModal({ isOpen: true, fieldToDelete: id, listName: listName });
  };
  const closeRemoveModal = () => {
    setRemoveModal({ isOpen: false, fieldToDelete: null });
  };

  // Delete the selected field
  const confirmDeleteField = async () => {
    if (removeModal.fieldToDelete) {
      await handleDeleteContactList(removeModal.fieldToDelete);
      closeRemoveModal();
    }
  };
  const [removeModal, setRemoveModal] = useState({
    isOpen: false,
    fieldToDelete: null,
  });
  const handleDeleteContactList = async (id) => {
    try {
      await axios.delete(`${API_BASE_URL}/contact-lists/delete/${id}`, {
        headers: getAuthHeaders(),
      });

      fetchContactLists();
    } catch (error) {
      console.error("Error deleting contact list:", error);
    }
  };

  const handleInlineStatusChange = async (id, newStatus) => {
    try {
      await axios.put(
        `${API_BASE_URL}/contact-lists/update/${id}`,
        { status: newStatus },
        {
          headers: getAuthHeaders(),
        }
      );

      Swal.fire({
        icon: "success",
        title: "Status Updated",
        text: `List status changed to "${newStatus}".`,
        timer: 2000,
        showConfirmButton: false,
      });

      fetchContactLists();
    } catch (error) {
      console.error("Failed to update status", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Could not update status.",
      });
    }
  };

  const formatDate12Hour = (isoDate) => {
    if (!isoDate) return "";
    const date = new Date(isoDate);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  const handleEditList = (list) => {
    setEditListId(list._id); // or list.id
    setNewListInput(list.listName);
    setNewListStatus(list.status);
    setNewListModal(true);
  };

  return (
    <Container fluid className="text-bg-light p-3">
      <Row>
        <Col lg="12" md="12">
          <h2 className="font-weight-bold">Contact Management</h2>
          <div className="card-body">
            <div className="d-flex flex-wrap align-items-center mb-3">
              <button
                style={{ fontWeight: '700', color: "black", border: "2px solid #c7c7c7", }} className="btn mr-3 bg-white shadow-sm"
                onClick={() => setAddModal(true)}
              >
                <span className="btn-label">
                  <i style={{ color: "#004992" }} className="fas fa-upload"></i> Import Contact
                </span>
              </button>
              <button
                style={{ fontWeight: '700', color: "black", border: "2px solid #c7c7c7", }} className="btn mr-3 bg-white shadow-sm"
                onClick={() => setExportModal(true)}
              >
                <span className="btn-label">
                  <i style={{ color: "#004992" }} className="fas fa-download"></i> Export Contact
                </span>
              </button>
              <button
                style={{ fontWeight: '700', backgroundColor: "#004992", }}
                className="btn mr-3 fw-bold shadow-sm px-5 text-white"
                onClick={() => {
                  setEditListId(null);
                  setNewListInput("");
                  setNewListStatus("active");
                  setNewListModal(true);
                }}
              >
                + New List
              </button>
              <button
                style={{ fontWeight: '700', color: "black", border: "2px solid #c7c7c7", }} className="btn mr-3 bg-white shadow-sm"
                onClick={() => setAddSingleContactModal(true)}
              >
                <span className="btn-label">
                  <i style={{ color: "#004992" }} className="fas fa-user-plus me-2"></i> Add Contact
                </span>
              </button>
              <input
                className="form-control text-dark font-weight-bold mr-3"
                placeholder="Search Lists"
                value={val}
                onChange={handleSearchChange}
                required
                style={{ flex: 1, minWidth: "200px" }}
              />
              <select
                className="form-control text-dark font-weight-bold "
                name="All Statuses"
                value={singleSelect}
                onChange={handleStatusChange}
                style={{ flex: 1, minWidth: "100px" }}
              >
                <option value="">All Statuses</option>
                <option value="2">Active</option>
                <option value="3">Inactive</option>
              </select>
            </div>

            {isLoading ? (
              <div className="text-center py-5">
                <Spinner color="primary" />
                <div className="mt-2 text-muted">Loading custom fields...</div>
              </div>
            ) : (
              <div
                style={{
                  border: "2px solid #c7c7c7",
                  borderRadius: "15px",
                  overflow: "hidden"
                }}
              >
                <Table
                  hover
                  responsive
                  className="custom-table"
                  style={{
                    marginBottom: 0 // removes spacing below the table that can break the illusion
                  }}
                >
                  <thead className="table-light">
                    <tr style={{ borderBottom: "2px solid #c7c7c7" }}>
                      <th style={{ fontWeight: "700", padding: ' 15px 40px' }}>List Name</th>
                      <th style={{ fontWeight: "700", padding: ' 15px 5px' }}>Contact Count</th>
                      <th style={{ fontWeight: "700", padding: ' 15px 5px' }}>Status</th>
                      <th style={{ fontWeight: "700", padding: ' 15px 5px' }}>Last Updated</th>
                      <th style={{ fontWeight: "700", padding: ' 15px 5px' }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {contactList.map((item, index) => (
                      <tr
                        key={item._id}
                        style={{
                          backgroundColor: "#fff",
                          borderBottom: "2px solid #c7c7c7"
                        }}
                      >
                        <td style={{ fontWeight: "700", paddingLeft: "40px" }}>{item.listName}</td>
                        <td style={{ fontWeight: "700" }}>
                          {parseInt(item.countContact || 0).toLocaleString()}
                        </td>
                        <td style={{ fontWeight: "700" }}>
                          <span
                            className="px-3 py-1 fw-bold"
                            style={{
                              backgroundColor: item.status === "active" ? "black" : "#fff",
                              color: item.status === "active" ? "white" : "black",
                              border: item.status === "active" ? "none" : "2px solid black",
                              display: "inline-block",
                              minWidth: "80px",
                              textAlign: "center",
                              borderRadius: "8px",
                              width: "10px"
                            }}
                          >
                            {item.status === "active" ? "Active" : "Inactive"}
                          </span>
                        </td>
                        <td style={{ fontWeight: "700" }}>{formatDate12Hour(item.updatedAt || new Date())}</td>
                        <td style={{ fontWeight: "700" }}>
                          <span
                            className="fw-bold text-dark mr-4 cursor-pointer"
                            onClick={() => handleEditList(item)}
                          >
                            Edit
                          </span>
                          <span 
                            className="fw-bold text-dark mr-4 cursor-pointer"
                            onClick={() => handleViewList(item)}
                          >
                            View
                          </span>
                          <span 
                            className="fw-bold text-primary mr-4 cursor-pointer"
                            onClick={() => handleDownloadExport(item._id, item.listName)}
                            title="Export this list to CSV"
                          >
                            Export
                          </span>
                          <span
                            className="fw-bold text-danger cursor-pointer"
                            onClick={() => openRemoveModal(item._id, item.listName)}
                          >
                            Delete
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>

            )}
          </div>
        </Col>
      </Row >
      <Modal show={exportModal} onHide={() => setExportModal(false)} centered>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Title style={{ margin: "0 0 10px 0", paddingLeft: '24px' }}>
          <div>
            <h3 style={{ fontWeight: 700 }} className="m-0">Export Network Data</h3>
            <p className="text-muted" style={{ marginBottom: "0", fontWeight: 700 }}>
              Export your lists and contacts
            </p>
          </div>
        </Modal.Title>

        <Modal.Body className="pt-2">
          <Form>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontWeight: "700" }}>List Name</Form.Label>
              <Form.Control
                as="select"
                className="form-select"
                value={selectedExportList}
                onChange={(e) => setSelectedExportList(e.target.value)}
                style={{ border: "2px solid #DBDBDB", borderRadius: "8px", fontWeight: "600" }}
              >
                <option value="all">All Contacts (All Lists)</option>
                {contactList.map((list) => (
                  <option key={list._id || list.id} value={list._id || list.id}>
                    {list.listName} ({parseInt(list.countContact || 0).toLocaleString()} contacts)
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            <Form.Group>
              <Form.Label style={{ fontWeight: "700" }}>Export File Type</Form.Label>
              <Form.Control
                as="select"
                className="form-select"
                value={exportFileType}
                onChange={(e) => setExportFileType(e.target.value)}
                style={{ border: "2px solid #DBDBDB", borderRadius: "8px", fontWeight: "600" }}
              >
                <option value="csv">CSV (.csv)</option>
              </Form.Control>
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer className="d-flex justify-content-between">
          <Button
            variant="link"
            style={{ fontWeight: "700", color: "black", textDecoration: "none" }}
            onClick={() => setExportModal(false)}
          >
            Back
          </Button>
          <Button
            style={{
              backgroundColor: "#004992",
              fontWeight: "700",
              border: "none",
              borderRadius: "8px"
            }}
            disabled={isExporting}
            onClick={() => handleDownloadExport()}
          >
            {isExporting ? <Spinner size="sm" /> : "Download"}
          </Button>
        </Modal.Footer>
      </Modal>



      <Modal show={addModal} onHide={() => setAddModal(false)} dialogClassName="fit-content-modal">
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Title style={{ margin: "0 0 10px 0", paddingLeft: '24px' }}>
          <h2 style={{ fontWeight: 700 }} className="m-0">Import Network Data</h2>
          <p style={{ fontWeight: 700 }} className="text-muted mb-0">Configure and validate your data import</p>
        </Modal.Title>
        <Modal.Body className="pt-0">
          <div className="max-w-2xl mx-auto p-8 bg-gray-100  rounded-xl ">
            <div className="d-flex justify-content-start gap-4 my-4 flex-wrap">
              {["Upload File", "Map Fields", "Configure", "Validate"].map((label, index) => {
                const isCompleted = step > index + 1;
                const isActive = step === index + 1;

                const showBlueCircle = isActive || isCompleted;

                return (
                  <div key={index} className="d-flex align-items-center gap-2">
                    <div
                      className="rounded-circle d-flex justify-content-center align-items-center"
                      style={{
                        width: "24px",
                        height: "24px",
                        backgroundColor: showBlueCircle ? "#004992" : "#e0e0e0",
                        color: showBlueCircle ? "#fff" : "#6c757d",
                        fontSize: "14px",
                        fontWeight: "bold",
                        marginRight: "10px"
                      }}
                    >
                      {index + 1}
                    </div>
                    <span
                      style={{
                        color: isActive
                          ? "#000"
                          : isCompleted
                            ? "#6c757d" // completed step label
                            : "#6c757d", // future step label
                        fontSize: "14px",
                        fontWeight: "700",
                        marginRight: "25px"
                      }}
                    >
                      {label}
                    </span>
                  </div>
                );
              })}
            </div>

            {step === 1 && (
              <div className="d-flex flex-column align-items-center justify-content-center bg-white text-center" style={{ minHeight: "300px", border: "4px dashed #c7c7c7", borderRadius: '10px' }}>
                <i className="fas fa-file" style={{ fontSize: "48px", color: "#6c757d" }}></i>
                <p style={{ fontWeight: 700 }} className="mt-3 text-muted">Drop your file here or click upload</p>
                <p style={{ fontWeight: 700 }} className="text-muted small">Supports CSV, XLS, XLSX up to 10MB</p>

                {file && (
                  <div className="text-success fw-semibold mt-2">
                    File selected: {file.name}
                  </div>
                )}

                <Button style={{ color: 'black', background: "#e0e0e0", fontWeight: "700", borderRadius: '8px' }}
                  className="mt-3 px-4 py-2"
                  onClick={() => document.getElementById("fileInput").click()}
                >
                  Upload
                </Button>

                <input
                  type="file"
                  accept=".csv,.xls,.xlsx"
                  id="fileInput"
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
              </div>
            )}
            {step === 2 && (
              <div className="mb-3">
                <h4 style={{ fontWeight: "700" }} className="fw-bold mb-3">Match Field Names</h4>
                <div className="border-top border-secondary pt-3">
                  <table className="table table-borderless">
                    <thead>
                      <tr>
                        <th style={{ fontWeight: "700" }}>Index</th>
                        <th style={{ fontWeight: "700" }}>CSV Header</th>
                        <th style={{ fontWeight: "700" }}>Target Database Field</th>
                      </tr>
                    </thead>
                    <tbody>
                      {csvHeaders.map((header, index) => (
                        <tr
                          key={header}
                          style={{
                            backgroundColor: index % 2 === 0 ? '#DBDBDB' : '#ffffff'
                          }}
                        >
                          <td className="fw-bold" style={{ width: "40px", fontWeight: "700", borderRight: '2px solid #c7c7c7' }}>
                            {String.fromCharCode(65 + index)}.
                          </td>
                          <td style={{ fontWeight: "700" }} className="fw-semibold">{header}</td>
                          <td>
                            <select
                              className="form-control text-dark font-weight-bold"
                              value={columnMappings[header] || ""}
                              onChange={(e) => {
                                setColumnMappings(prev => ({
                                  ...prev,
                                  [header]: e.target.value
                                }));
                              }}
                            >
                              <option value="">Select Field</option>
                              <option value="firstName">First Name</option>
                              <option value="lastName">Last Name</option>
                              <option value="phone">Phone Number</option>
                              <option value="location">Location</option>
                              {customFields.map((field) => (
                                <option key={field._id || field.name} value={field.name}>
                                  {field.label || field.name} (Custom)
                                </option>
                              ))}
                            </select>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                </div>

                <div className="mt-3 d-flex align-items-center">
                  <span style={{ fontWeight: "700" }} className="text-dark small me-2">
                    File: <span className="text-muted">{file ? file.name : ""}</span>
                  </span>
                  <span
                    style={{ color: "#0090ff", fontWeight: "700" }}
                    className="small cursor-pointer ml-3"
                    onClick={() => {
                      setStep(1); // go back to step 1 to change file
                    }}
                  >
                    Change
                  </span>
                </div>
              </div>
            )}
            {step === 3 && (
              <>
                {!isCreatingNewList ? (
                  <div className="mb-3">
                    <h4 style={{ fontWeight: "700" }} className="fw-bold mb-3">Choose List</h4>
                    <hr />

                    <table className="table table-borderless">
                      <thead>
                        <tr>
                          <th style={{ fontWeight: "700" }}>CSV Header</th>
                          <th style={{ fontWeight: "700" }}>Mapped Target</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Object.entries(columnMappings).map(([header, targetField], index) => {
                          if (!targetField) return null;
                          return (
                            <tr
                              key={header}
                              style={{
                                backgroundColor: index % 2 === 0 ? '#DBDBDB' : '#ffffff'
                              }}
                            >
                              <td style={{ fontWeight: "700" }}>{header}</td>
                              <td style={{ fontWeight: "700" }}>
                                {targetField === "phone" ? "Phone Number" :
                                 targetField === "firstName" ? "First Name" :
                                 targetField === "lastName" ? "Last Name" : "Location"}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>

                    <div className="mt-4 d-flex align-items-center justify-content-between">
                      <select
                        className="form-control w-50"
                        style={{ color: '#000000', fontWeight: "700", border: '2px solid #DBDBDB' }}
                        value={selectedField}
                        onChange={(e) => setSelectedField(e.target.value)}
                      >
                        <option value="">Choose Existing List</option>

                        {contactList.length > 0 ? (
                          contactList.map((dataItem, index) => (
                            <option key={dataItem.id || dataItem._id} value={dataItem.listName}>
                              {dataItem.listName}
                            </option>
                          ))
                        ) : newListName.trim() !== "" ? (
                          <option value={newListName}>{newListName}</option>
                        ) : null}
                      </select>

                      <button
                        className="btn btn-primary fw-bold"
                        style={{ marginLeft: "20px", padding: "6px 20px", background: '#004992' }}
                        onClick={handleNewListClick}
                      >
                        + New List
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="mb-3">
                    <h4 style={{ fontWeight: "700" }} className="fw-bold mb-3">Create New List</h4>
                    <hr />
                    <label style={{ fontWeight: "700" }}>List Name</label>
                    <input
                      className="form-control mt-2"
                      value={newListName}
                      placeholder="Enter list name"
                      onChange={(e) => {
                        setNewListName(e.target.value);
                        if (newListNameError) setNewListNameError(""); // clear error
                      }}
                    />
                    {newListNameError && (
                      <div className="text-danger mt-2" style={{ fontWeight: "600" }}>
                        {newListNameError}
                      </div>
                    )}

                  </div>
                )}
              </>
            )}
            {step === 4 && (
              <div className="mb-3">
                <h4 style={{ fontWeight: "700" }} className="fw-bold mb-3">Validate Information</h4>
                <hr />
                <table className="table table-borderless">
                  <thead>
                    <tr>
                      <th style={{ fontWeight: "700" }}>CSV Header</th>
                      <th style={{ fontWeight: "700" }}>Mapped Target</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.entries(columnMappings).map(([header, targetField], index) => {
                      if (!targetField) return null;
                      return (
                        <tr
                          key={header}
                          style={{
                            backgroundColor: index % 2 === 0 ? '#DBDBDB' : '#ffffff'
                          }}
                        >
                          <td style={{ fontWeight: "700" }}>{header}</td>
                          <td style={{ fontWeight: "700" }}>
                            {targetField === "phone" ? "Phone Number" :
                             targetField === "firstName" ? "First Name" :
                             targetField === "lastName" ? "Last Name" : "Location"}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                <div className="mt-3 ml-3">
                  <span style={{ fontWeight: "700" }} className="text-dark small me-2">
                    Target List: <strong className="text-primary">{selectedField || newListName}</strong>
                  </span>
                  <br />
                  <span style={{ fontWeight: "700" }} className="text-dark small me-2">
                    Total Contacts to Import: <strong className="text-primary">{csvData.length}</strong>
                  </span>
                </div>
              </div>
            )}
            <div className="mt-4 mb-2 d-flex justify-content-between ">
              <button
                onClick={() => setStep((prev) => Math.max(prev - 1, 1))}
                className="btn border mr-2"
                style={{ background: 'transparent', color: "gray", fontWeight: "700" }}
                disabled={isSavingList}
              > Back
              </button>
              <button
                onClick={async () => {
                  if (step === 3) {
                    if (isCreatingNewList) {
                      if (!newListName.trim()) {
                        setNewListNameError("List name is required.");
                        return;
                      }
                      
                      // Trigger new list creation on backend
                      setIsSavingList(true);
                      try {
                        const response = await axios.post(
                          `${API_BASE_URL}/contact-lists/add`,
                          { listName: newListName, status: "active" },
                          { headers: getAuthHeaders() }
                        );
                        if (response.data?.success) {
                          await fetchContactLists();
                          setSelectedField(newListName);
                          setIsCreatingNewList(false);
                          setNewListNameError("");
                          setStep(4);
                        } else {
                          Swal.fire("Error", response.data?.message || "Failed to create contact list.", "error");
                        }
                      } catch (err) {
                        console.error(err);
                        Swal.fire("Error", "Failed to create contact list.", "error");
                      } finally {
                        setIsSavingList(false);
                      }
                      return;
                    }
                    if (!selectedField) {
                      Swal.fire("Error", "Please select a contact list.", "error");
                      return;
                    }
                    setStep(4);
                    return;
                  }

                  if (step === 4) {
                    // Start actual upload process
                    const targetList = contactList.find(c => c.listName === (selectedField || newListName));
                    if (!targetList) {
                      Swal.fire("Error", "Selected list not found. Go back and select or create a list.", "error");
                      return;
                    }

                    const phoneHeader = Object.keys(columnMappings).find(hdr => columnMappings[hdr] === "phone");
                    if (!phoneHeader) {
                      Swal.fire("Error", "You must map at least one column to Phone Number.", "error");
                      return;
                    }

                    const mappedContacts = csvData.map(row => {
                      const contact = {};
                      Object.entries(columnMappings).forEach(([hdr, target]) => {
                        if (target && row[hdr] !== undefined && row[hdr] !== null) {
                          contact[target] = row[hdr].toString().trim();
                        }
                      });
                      return contact;
                    }).filter(c => c.phone);

                    if (mappedContacts.length === 0) {
                      Swal.fire("Error", "No contacts with phone numbers found to import.", "error");
                      return;
                    }

                    setIsSavingList(true);
                    try {
                      const response = await axios.post(`${API_BASE_URL}/contacts/upload_csv`, {
                        contactListId: targetList._id || targetList.id,
                        contacts: mappedContacts
                      }, {
                        headers: getAuthHeaders()
                      });

                      Swal.fire({
                        icon: "success",
                        title: "Import Successful",
                        text: response.data.message || `Successfully imported ${response.data.importedCount} contacts.`
                      });

                      fetchContactLists();
                      setAddModal(false);
                      setStep(1);
                      setFile(null);
                      setCsvData([]);
                      setCsvHeaders([]);
                      setColumnMappings({});
                    } catch (err) {
                      console.error("Failed to import contacts:", err);
                      Swal.fire("Import Failed", err.response?.data?.message || "An error occurred during import.", "error");
                    } finally {
                      setIsSavingList(false);
                    }
                    return;
                  }
                  
                  if (step === 2) {
                    const phoneHeader = Object.keys(columnMappings).find(hdr => columnMappings[hdr] === "phone");
                    if (!phoneHeader) {
                      Swal.fire("Error", "You must map at least one column to Phone Number.", "error");
                      return;
                    }
                  }

                  setStep((prev) => Math.min(prev + 1, 4));
                }}

                style={{ background: '#004992', fontWeight: "700" }}
                className="btn mr-2"
                disabled={isSavingList}
              >
                {isSavingList ? "Processing..." : "Continue"}
              </button>


            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={removeModal.isOpen} onHide={closeRemoveModal} centered>
        <Modal.Header toggle={closeRemoveModal}>Confirm Removal</Modal.Header>
        <Modal.Body>
          Are you sure you want to delete the contact list "
          {removeModal.listName}"?
        </Modal.Body>
        <Modal.Footer>
          <Button
            color="secondary"
            onClick={closeRemoveModal}
            className="bg-secondary"
          >
            Cancel
          </Button>

          <Button
            color="danger"
            onClick={confirmDeleteField}
            className="bg-danger"
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={newListModal}
        onHide={() => {
          setNewListModal(false);
          setEditListId(null);
          setNewListInput("");
          setNewListStatus("active");
        }}
        centered
      >
        <Modal.Header closeButton></Modal.Header>

        <Modal.Title style={{ margin: "0 0 10px 0", paddingLeft: '24px' }}>
          <div>
            <h3 style={{ fontWeight: 700 }} className="m-0">
              {editListId ? "Edit Contact List" : "Create a New List"}
            </h3>
            <p className="text-muted" style={{ marginBottom: "0", fontWeight: 700 }}>
              Organize new and existing contacts with a {editListId ? "modified" : "new"} list
            </p>
          </div>
        </Modal.Title>

        <Modal.Body className="pt-2">
          <Form>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontWeight: "700" }}>List Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter list name"
                value={newListInput}
                onChange={(e) => setNewListInput(e.target.value)}
                style={{
                  border: "2px solid #DBDBDB",
                  borderRadius: "8px",
                  fontWeight: "600",
                }}
              />
            </Form.Group>

            {/* <Form.Group>
              <Form.Label style={{ fontWeight: "700" }}>Status</Form.Label>
              <Form.Control
                as="select"
                className="form-select"
                value={newListStatus}
                onChange={(e) => setNewListStatus(e.target.value)}
                style={{
                  border: "2px solid #DBDBDB",
                  borderRadius: "8px",
                  color: "#DBDBDB",
                  fontWeight: "600",
                }}
              >
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </Form.Control>
            </Form.Group> */}
          </Form>
        </Modal.Body>

        <Modal.Footer className="d-flex justify-content-between">
          <Button
            style={{ fontWeight: "700", color: "black", textDecoration: "none", border: "2px solid #DBDBDB", borderRadius: "8px" }}
            onClick={() => setNewListModal(false)}
          >
            Back
          </Button>
          <Button
            style={{
              backgroundColor: "#004992",
              fontWeight: "700",
              border: "none",
              borderRadius: "8px"
            }}
            disabled={isSavingList}
            onClick={async () => {
              if (!newListInput.trim()) return;

              setIsSavingList(true);
              try {
                const payload = {
                  listName: newListInput,
                  status: newListStatus,
                };

                const url = editListId
                  ? `${API_BASE_URL}/contact-lists/update/${editListId}`
                  : `${API_BASE_URL}/contact-lists/add`;

                const method = editListId ? axios.put : axios.post;

                const response = await method(url, payload, {
                  headers: getAuthHeaders(),
                });

                if (response.data?.success) {
                  Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: response.data.message || "Contact list saved successfully.",
                    timer: 2000,
                    showConfirmButton: false,
                  });
                }

                fetchContactLists();
                setNewListModal(false);
                setEditListId(null);
                setNewListInput("");
                setNewListStatus("active");
              } catch (err) {
                console.error("Failed to save list", err);
                Swal.fire({
                  icon: "error",
                  title: "Error",
                  text: "Failed to save contact list.",
                });
              } finally {
                setIsSavingList(false);
              }
            }}
          >
            {isSavingList ? "Saving..." : editListId ? "Update" : "Continue"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={addSingleContactModal} onHide={() => setAddSingleContactModal(false)} centered>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Title style={{ margin: "0 0 10px 0", paddingLeft: '24px' }}>
          <div>
            <h3 style={{ fontWeight: 700 }} className="m-0">Add Single Contact</h3>
            <p className="text-muted" style={{ marginBottom: "0", fontWeight: 700 }}>
              Manually add a single contact to a list
            </p>
          </div>
        </Modal.Title>
        <Modal.Body className="pt-2">
          <Form>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontWeight: "700" }}>First Name</Form.Label>
              <Form.Control
                type="text"
                name="firstName"
                placeholder="Enter first name"
                value={singleContactForm.firstName}
                onChange={handleSingleContactChange}
                style={{ border: "2px solid #DBDBDB", borderRadius: "8px", fontWeight: "600" }}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontWeight: "700" }}>Last Name</Form.Label>
              <Form.Control
                type="text"
                name="lastName"
                placeholder="Enter last name"
                value={singleContactForm.lastName}
                onChange={handleSingleContactChange}
                style={{ border: "2px solid #DBDBDB", borderRadius: "8px", fontWeight: "600" }}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontWeight: "700" }}>Phone Number</Form.Label>
              <Form.Control
                type="text"
                name="phone"
                placeholder="(555) 555-5555"
                value={singleContactForm.phone}
                onChange={handleSingleContactChange}
                style={{ border: "2px solid #DBDBDB", borderRadius: "8px", fontWeight: "600" }}
              />
            </Form.Group>
            {customFields.map((field) => (
              <Form.Group className="mb-3" key={field._id || field.name}>
                <Form.Label style={{ fontWeight: "700" }}>{field.label || field.name}</Form.Label>
                <Form.Control
                  type="text"
                  name={field.name}
                  placeholder={`Enter ${field.label || field.name}`}
                  value={singleContactForm[field.name] || ""}
                  onChange={handleSingleContactChange}
                  style={{ border: "2px solid #DBDBDB", borderRadius: "8px", fontWeight: "600" }}
                />
              </Form.Group>
            ))}
            <Form.Group className="mb-3">
              <Form.Label style={{ fontWeight: "700" }}>Target List</Form.Label>
              <Form.Control
                as="select"
                name="contactListId"
                className="form-select"
                value={singleContactForm.contactListId}
                onChange={handleSingleContactChange}
                style={{ border: "2px solid #DBDBDB", borderRadius: "8px", fontWeight: "600" }}
              >
                <option value="" disabled>Select List...</option>
                {contactList.map((list) => (
                  <option key={list._id} value={list._id}>{list.listName}</option>
                ))}
              </Form.Control>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between">
          <Button
            style={{ fontWeight: "700", color: "black", border: "2px solid #DBDBDB", borderRadius: "8px", background: "white" }}
            onClick={() => setAddSingleContactModal(false)}
          >
            Cancel
          </Button>
          <Button
            style={{ backgroundColor: "#004992", fontWeight: "700", border: "none", borderRadius: "8px" }}
            disabled={isSavingSingleContact}
            onClick={handleAddSingleContact}
          >
            {isSavingSingleContact ? "Adding..." : "Add Contact"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={viewContactsModal} onHide={() => setViewContactsModal(false)} size="lg" centered>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Title style={{ margin: "0 0 10px 0", paddingLeft: '24px' }}>
          <div>
            <h3 style={{ fontWeight: 700 }} className="m-0">
              {viewingList ? viewingList.listName : "Contacts"}
            </h3>
            <p className="text-muted" style={{ marginBottom: "0", fontWeight: 700 }}>
              Viewing contacts in this list
            </p>
          </div>
        </Modal.Title>
        <Modal.Body className="pt-2">
          {isLoadingContacts ? (
            <div className="text-center py-5">
              <Spinner color="primary" />
              <div className="mt-2 text-muted">Loading contacts...</div>
            </div>
          ) : (
            <Table hover responsive>
              <thead className="table-light">
                <tr>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Phone Number</th>
                </tr>
              </thead>
              <tbody>
                {listContacts.length > 0 ? (
                  listContacts.map((contact) => (
                    <tr key={contact._id}>
                      <td>{contact.firstName || "N/A"}</td>
                      <td>{contact.lastName || "N/A"}</td>
                      <td>{contact.phone}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center py-4">No contacts found in this list.</td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between">
          <Button
            style={{ fontWeight: "700", color: "black", border: "2px solid #DBDBDB", borderRadius: "8px", background: "white" }}
            onClick={() => setViewContactsModal(false)}
          >
            Close
          </Button>
          {viewingList && (
            <Button
              style={{ backgroundColor: "#004992", fontWeight: "700", border: "none", borderRadius: "8px" }}
              disabled={isExporting}
              onClick={() => handleDownloadExport(viewingList._id || viewingList.id, viewingList.listName)}
            >
              <i className="fas fa-download mr-2"></i>
              {isExporting ? "Exporting..." : "Export CSV"}
            </Button>
          )}
        </Modal.Footer>
      </Modal>

    </Container >
  );
}

export default ContactLists;
